import React from 'react';
import { TrackingLink, ItemTrackingBlock, NotShippedInfo } from './styledComponents';

const ITEM_NOT_SHIPPED_MESSAGE = 'Tracking information will be available when item has shipped';

const ItemTrackingDetails = ({ lineData }) => {
  const { shippingMethod, trackingNumbers = [] } = lineData;

  if (!trackingNumbers.length) {
    return <NotShippedInfo>{ITEM_NOT_SHIPPED_MESSAGE}</NotShippedInfo>;
  }

  return (
    <ItemTrackingBlock>
      {shippingMethod?.toUpperCase().includes('LTL') ? (
        <div className="pallet-list-container">
          <b>Pallet Number:</b>
          <ul className="pallet-number-list">
            {trackingNumbers.map((trackingNumberOrLpnItem) => (
              <li key={trackingNumberOrLpnItem.trackingNumber}>
                {trackingNumberOrLpnItem.trackingNumber}
              </li>
            ))}
          </ul>
        </div>
      ) : (
        <>
          <b>Tracking Number:</b>&nbsp;
          {trackingNumbers.map((trackingNumberOrLpnItem, index) => (
            <React.Fragment key={trackingNumberOrLpnItem.trackingNumber}>
              {trackingNumberOrLpnItem.trackingURL ? (
                <TrackingLink target="_blank" href={trackingNumberOrLpnItem.trackingURL}>
                  {trackingNumberOrLpnItem.trackingNumber}
                </TrackingLink>
              ) : (
                <span>{trackingNumberOrLpnItem.trackingNumber}</span>
              )}
              {trackingNumbers.length > 1 && index < trackingNumbers.length - 1 ? <>,&nbsp;</> : ''}
            </React.Fragment>
          ))}
        </>
      )}
    </ItemTrackingBlock>
  );
};

export { ItemTrackingDetails };
